import {createTheme} from '@mui/material/styles/index.js';
import {deepmerge} from '@mui/utils';

import getComponentOverrides from './Overrides.jsx';
import typography from './Typography.js';
import {DARK as DARK_PALETTE, LIGHT as LIGHT_PALETTE} from './Palettes.js';
import {DEFAULT_THEME_VARIANT, THEME_VARIANTS} from './Constants.js';

/**
 * Theme creator
 * @param {string} [variant="dark"] - theme variant, either dark or light
 * @returns {object}
 */
const createPlanetTheme = (variant = DEFAULT_THEME_VARIANT) => {
  const MUITheme = createTheme({
    palette: {
      mode: variant,
    },
  });

  return createTheme(
    deepmerge(MUITheme, {
      components: {
        ...getComponentOverrides(variant),
      },
      palette: variant === THEME_VARIANTS.DARK ? DARK_PALETTE : LIGHT_PALETTE,
      typography,
    }),
  );
};

// Dark & Light Theme variants
export const DARK_THEME = createPlanetTheme(THEME_VARIANTS.DARK);
export const LIGHT_THEME = createPlanetTheme(THEME_VARIANTS.LIGHT);

// Default theme
export const DEFAULT_THEME =
  DEFAULT_THEME_VARIANT === THEME_VARIANTS.DARK ? DARK_THEME : LIGHT_THEME;

export default {
  DEFAULT_THEME,
  DARK_THEME,
  LIGHT_THEME,
};
